import { useSelector } from "react-redux";

import { ButtonLink } from "@seneca/senekit";

import { linkToTransferPremiumForm } from "common/links";

import { getUserEmail } from "seneca-common/features/user/state";

export default function ManualTransferButton() {
  const userEmail = useSelector(getUserEmail);
  return (
    <ButtonLink
      width={["100%", "auto"]}
      to={linkToTransferPremiumForm(userEmail)}
    >
      Contact us
    </ButtonLink>
  );
}
